import RepoCards from "../../../../src/components/v2/RepoCards";
import * as React from 'react';
export default {
  RepoCards,
  React
};